export const kioskSettlementsResource = {
  name: 'Octopus settlements',
  fields: {
    createdAt: 'Recorded at', kioskName: 'Kiosk', siteName: 'Premises', outcome: 'Result', settledAt: 'Settled at', window: 'Covers',
    reader: 'Reader', ours: 'Our record', deducts: 'payments', refunds: 'refunds', matched: 'Match', failureReason: 'Reason',
  },
  outcomes: { ok: 'Settled', failed: 'Failed', interrupted: 'Interrupted' },
  filters: { siteId: 'Premises', kioskId: 'Kiosk', outcome: 'Result', from: 'From', to: 'To' },
  match: { matched: 'Matches', different: 'Differs' },
  window: { since: '%{start} to %{end}', fromStart: 'Up to %{end} (first settlement)' },
  figures: '%{count} · HK$%{total}',
  differenceLine: 'Payments %{deducts} (HK$%{deductTotal}), refunds %{refunds} (HK$%{refundTotal})',
  readerMissing: 'The reader reported no totals',
  flags: {
    readerChanged: 'The reader changed since the previous settlement',
    interruptedInWindow: 'An interrupted settlement in this period may have settled part of it',
  },
  overdue: {
    title: 'Settlement overdue',
    line: '%{kiosk} (%{site}): last settled %{at}, %{hours} hours ago',
    never: '%{kiosk} (%{site}): never settled, and it has Octopus payments',
    loadFailed: 'Could not check for overdue settlements',
  },
  actions: { export: 'Export CSV' },
  messages: { exportFailed: 'Export failed' },
};
export const kioskSettlements = kioskSettlementsResource;
